import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useButton, useCurrency, useI18n } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import { TransparentButton } from '~Styles';
import { GeneralPaymentMethodIcon, methodToIconMap } from '~Components/PayWithButton';
import { PaymentMethod } from '~reducers';

const Row = styled.div``;

export const ListItemWrapper = styled(TransparentButton)`
  height: 64px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  color: var(--colorBlueGray900);
  font-weight: 600;
  font-size: 14px;
  letter-spacing: var(--letterSpacing);
  gap: 8px;
`;

interface Props {
  method: PaymentMethod;
  amount: number;
  onClick: () => void;
}

const ListItem: FC<Props> = ({ method, amount, onClick }) => {
  const { i18n } = useI18n();
  const currency = useCurrency();

  const handleClick = useButton({
    onClick,
    disabled: amount > (method.maxAmount ?? Infinity),
    disabledToast:
      method.maxAmount != null
        ? i18n('POS.PayWith.MaxAmountExceeded', currency.format(method.maxAmount))
        : undefined,
  });

  return (
    <Row>
      <ListItemWrapper fluid {...handleClick}>
        <Icon
          color="var(--colorBlueGray600)"
          src={methodToIconMap[method.id] || GeneralPaymentMethodIcon}
        />
        {method.title}
      </ListItemWrapper>
    </Row>
  );
};

export default ListItem;
